<template>
  <div class="one-measurement-wrapper">
    <PopoverMeasurement
      :reading="currentMeasurement.reading"
      :label="currentMeasurement.label"
      :unitsLabel="currentMeasurement.unitsLabel"
      :imageSrc="currentMeasurement.imageSrc"
      :showInactiveReading="showInactiveReadings"
      :customClass="`${size}-size bolded-reading grey-empty-reading`"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import PopoverMeasurement from '../content/measurements/popoverMeasurement.vue'
import { MeasurementType, measurementTypesKey } from '@/services/device-measurements'
import { getPopoverMeasurementData } from '@/helpers/widgets/helper'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { SensorReadings } from '@/services/device-service/devices'

type MeasurementSize = 'medium' | 'large'

export default defineComponent({
  name: 'OneMeasurementMonitoring',
  components: {
    PopoverMeasurement
  },
  props: {
    deviceId: { type: String, default: '' },
    selectedParameter: {
      type: Number as PropType<MeasurementType>,
      default: MeasurementType.Pm25
    },
    readings: {
      type: Object as PropType<SensorReadings>,
      default: null
    },
    size: { type: String as PropType<MeasurementSize>, default: 'large' },
    showInactiveReadings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    deviceType(): string {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_DEVICE_TYPE_BY_DEVICE_ID}`
      ](this.deviceId) as string
    },
    currentMeasurement() {
      const readings = this.readings as SensorReadings
      return getPopoverMeasurementData(
        this.$t.bind(this),
        {
          measurementName: measurementTypesKey[this.selectedParameter],
          deviceType: this.deviceType,
          readings
        },
        {}
      )
    }
  }
})
</script>

<style lang="scss" scoped>
.one-measurement-wrapper {
  :deep(.popover-measurement) {
    display: block;

    .reading {
      justify-content: center;
    }

    .label {
      width: 100%;
      justify-content: center;
    }

    img {
      height: unset;
    }
  }

  :deep(.empty-reading.large-size) {
    .reading {
      margin-top: 0 !important;
    }
  }

  :deep(.empty-reading.medium-size) {
    .reading {
      font-size: 2.8rem;
    }
  }

  :deep(.large-size) {
    margin: 35px 0;
  }

  :deep(.medium-size) {
    margin: 12px 0;
  }
}
</style>
